import { INVISIBLE_ERROR } from 'components-machine';

export const isVisibleError = (errorMessage: string | undefined): boolean =>
  !!errorMessage && errorMessage !== INVISIBLE_ERROR;
